import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, Button, TextField } from "@mui/material";
import toast from "react-hot-toast";
import CustomerProfile from "./Customerprofile";
import { X } from "lucide-react";
import getactions from "../../common/getactions";

function createData(
  id,
  name,
  loggedIn,
  email,
  mobile,
  isVerified,
  isDocumentUploaded,
  isDocVerified,
  viewDocuments,
  block,
) {
  return {
    id,
    name,
    loggedIn,
    email,
    mobile,
    isVerified,
    isDocumentUploaded,
    isDocVerified,
    viewDocuments,
    block,
  };
}

const Customers = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [allCustomersList, setAllCustomerList] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [copied, setCopied] = useState(false);
  const [clickedCustomerId, setClickedCustomerId] = useState(null);
  const [documentsMap, setDocumentsMap] = useState({});
  const [openTab, setOpenTab] = useState(false);
  const [seletecRow, setSelectedRow] = useState(null);
  const [selectedSearchButton, setSelectedSearchButton] = useState("");
  const [searchValues, setSearchValues] = useState(null);
  const [confirmRowId, setConfirmRowId] = React.useState(null);
  const profile = JSON.parse(localStorage.getItem("profile"));
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const searchByFilter = [
    {
      label: "Customer Email",
      value: "email",
    },
    {
      label: "Customer Contact",
      value: "mobile",
    },
  ];

  useEffect(() => {
    getAllCustomersList();
  }, []);

  const getAllCustomersList = async (
    customPage = paginationModel.page,
    customRowsPerPage = paginationModel.pageSize,
    searchType = selectedSearchButton,
    searchValue = searchValues,
  ) => {
    setLoading(true);

    const offset = customPage * customRowsPerPage;
    let query = "";

    if (searchType === "email" && searchValue) {
      query += `&email=${searchValue}`;
    } else if (searchType === "mobile" && searchValue) {
      query += `&mobile=${searchValue}`;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=${customRowsPerPage}&offset=${offset}&isSystemUser=false${query}`,
      );
      const data = await response.json();

      if (data?.statusCode === "0100") {
        setAllCustomerList(data.entities.rows);
        setTotalCount(data.entities.count || 0);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 70,
      align: "start",
      sortable: false,
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 190,
      align: "start",
      sortable: false,
    },
    {
      field: "loggedIn",
      headerName: "Logged In",
      minWidth: 150,
      align: "start",
      sortable: false,
      renderCell: (params) => {
        const isLogged = params.row?.loggedIn;

        return <span>{isLogged ? "True" : "False"}</span>;
      },
    },
    {
      field: "email",
      headerName: "Email Id",
      minWidth: 300,
      align: "start",
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile Number",
      minWidth: 200,
      align: "start",
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "isDocVerified",
      headerName: "Is Document Verified",
      minWidth: 250,
      align: "start",
      renderCell: (params) => {
        const isDocVerified = params.value;

        return (
          <span
            className={`font-semibold ${
              isDocVerified ? "text-green-600" : "text-red-600"
            }`}
          >
            {isDocVerified ? "Document Verified" : "Document Not Verified"}
          </span>
        );
      },
    },
    {
      field: "isVerified",
      headerName: "User Verified",
      minWidth: 200,
      align: "start",
      renderCell: (params) => {
        const isVerified = params.value;

        return <span>{isVerified ? "Verified" : "Not Verified"}</span>;
      },
    },
    {
      field: "block",
      headerName: "Block",
      minWidth: 150,
      align: "start",
      renderCell: (params) => {
        const isApproved = params.row.isApproved;
        const rowId = params.row.id;
        const isConfirming = confirmRowId === rowId;

        const handleApprove = async (e) => {
          e.stopPropagation();
          try {
            const response = await fetch(`${apiUrl}/api/users`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `${token}`,
              },
              body: JSON.stringify({
                isVerified: false,
                isArchived: true,
                id: rowId,
              }),
            });

            const data = await response.json();

            if (data?.statusCode === "0100") {
              toast.success("User Blocked");
              await getAllCustomersList(
                paginationModel?.page,
                paginationModel?.pageSize,
              );
            } else {
              toast.error(data?.msg);
            }
          } catch (error) {
            console.error("Error approving comment:", error);
          } finally {
            setConfirmRowId(null);
          }
        };

        // Already approved
        if (isApproved) {
          return (
            <button
              disabled
              className="px-4 py-1.5 text-sm font-semibold rounded-md bg-gray-300 text-gray-600 cursor-not-allowed"
            >
              Blocked
            </button>
          );
        }

        // Confirmation buttons (ONLY for this row)
        if (isConfirming) {
          return (
            <div className="flex gap-2 mt-3">
              <button
                onClick={(e) => {
                  handleApprove(e);
                }}
                className="px-3 py-1 text-sm font-semibold rounded-md bg-blue-600 text-white hover:bg-blue-700"
              >
                Yes
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setConfirmRowId(null);
                }}
                className="px-3 py-1 text-sm font-semibold rounded-md bg-red-500 text-white hover:bg-red-600"
              >
                No
              </button>
            </div>
          );
        }

        // Default Approve
        return (
          actionsToAccess?.includes("Update Customer") && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                setConfirmRowId(rowId);
              }}
              className="px-4 py-1.5 text-sm font-semibold rounded-md bg-red-600 text-white hover:bg-red-700"
            >
              Block
            </button>
          )
        );
      },
    },
  ];

  const rows =
    (allCustomersList &&
      allCustomersList?.map((item) =>
        createData(
          item?.id,
          item?.name,
          item?.loggedIn,
          item?.email,
          item?.mobile,
          item?.isVerified || "-",
          item?.isDocumentUploaded,
          item?.isDocVerified,
        ),
      )) ||
    [];

     const handleGenerate = async () => {    
        try {
          const endpoint = `/api/reports/users`;
          const url = `${apiUrl}${endpoint}`;
          const response = await toast.promise(
            fetch(url, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
              },
            }),
            {
              loading: "Generating report...",
              success: "Report generated successfully!",
              error: "Failed to generate report!",
            },
          );
    
          const data = await response.json();
          if (data?.statusCode === "0100" && data?.entities?.result === -1) {
            toast.error(data?.entities?.msg, {
              position: "top-center",
              style: {
                background: "white", // override background
                color: "red",
                fontWeight: "medium",
                marginBottom: "20px",
              },
            });
          } else {            
            window.open(data.entities.Location, "_blank");
            toast.success("Report generated successfully", {
              position: "top-center",
              style: {
                background: "blue", // override background
                color: "white",
                fontWeight: "medium",
                marginBottom: "20px",
              },
            });
          }
        } catch (error) {
          console.error("Error generating report:", error);
        }
      };

  return (
    <div className="mt-4">
      {!openTab ? (
        <>
        <h1 className="text-lg font-bold">View All Customers</h1>
          <div className="my-4 p-3 rounded-lg flex flex-col gap-6 bg-white">
            <div className="flex items-center gap-6">
              <h1 className="min-w-[100px] text-start">Search By :</h1>

              <div className="flex flex-wrap gap-4">
                {searchByFilter.map((item, index) => {
                  const isActive = item?.value === selectedSearchButton;

                  return (
                    <button
                      key={index}
                      onClick={() => {
                        setSearchValues(null);
                        setSelectedSearchButton(item?.value);
                      }}
                      className={`h-[40px] w-40 rounded-xl flex items-center justify-center transition-transform duration-200 active:scale-[0.95] border
              ${
                isActive
                  ? "bg-[linear-gradient(45deg,#efad21,#ffd60f)] border-transparent text-white font-medium shadow-md"
                  : "bg-white border-black text-black hover:bg-gray-100"
              }`}
                    >
                      {item?.label}
                    </button>
                  );
                })}
              </div>

              <div className="flex-1">
                <TextField
                  fullWidth
                  id="standard-basic"
                  label="Enter the value to search"
                  variant="standard"
                  value={searchValues}
                  onChange={(e) => setSearchValues(e.target.value)}
                />
              </div>

              <div className="flex items-center gap-4">
                <button
                  onClick={() => {
                    setPaginationModel({ page: 0, pageSize: 20 });
                    getAllCustomersList();
                  }}
                  className="w-12 h-12 rounded-full bg-violet-500 group shadow-xl flex items-center justify-center relative overflow-hidden"
                >
                  <svg
                    className="w-6 h-6 text-white relative z-10"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeWidth="2"
                      d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                    />
                  </svg>

                  <div className="w-full h-full rotate-45 absolute left-[32%] top-[32%] bg-green-500 group-hover:-left-[100%] group-hover:-top-[100%] duration-1000"></div>
                  <div className="w-full h-full -rotate-45 absolute -left-[32%] -top-[32%] group-hover:left-[100%] group-hover:top-[100%] bg-green-500 duration-1000"></div>
                </button>

                <button
                  onClick={() => {
                    setPaginationModel({ page: 0, pageSize: 20 });
                    setSelectedSearchButton(null);
                    setSearchValues("");
                    getAllCustomersList(0, 20, null, null);
                  }}
                  className="cursor-pointer transition-all bg-blue-500 text-white px-4 py-2 rounded-lg
          border-blue-600 border-b-[4px]
          hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px]
          active:border-b-[2px] active:brightness-90 active:translate-y-[2px]"
                >
                  Reset
                </button>
              </div>

              <div className="flex justify-between items-center mb-4">
                <button
                  title="Download Customer Report"
                  onClick={() => {
                    handleGenerate()
                  }}
                  className="p-2 rounded-full backdrop-blur-lg border border-blue-500/20 
      bg-gradient-to-tr from-white/60 to-white/40 shadow-lg 
      hover:shadow-2xl hover:shadow-blue-500/30 hover:scale-110 
      active:scale-95 transition-all duration-300 cursor-pointer 
      hover:border-blue-500/50 group relative overflow-hidden"
                >
                  <div
                    className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-400/20 to-transparent 
      -translate-x-full group-hover:translate-x-full transition-transform duration-700"
                  />

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="w-6 h-6 relative z-10"
                    fill="currentColor"
                  >
                    <path d="M12 16l4-5h-3V4h-2v7H8l4 5zm6 2H6v2h12v-2z" />
                  </svg>
                </button>
              </div>
            </div>

            <div className="flex items-end gap-6"></div>
          </div>

          <Commongrid
            rows={rows}
            columns={columns}
            totalCount={totalCount}
            handleViewClick={(params) => {
              setSelectedRow(params?.id);
              setOpenTab(true);
            }}
            api={getAllCustomersList}
            setPaginationModel={setPaginationModel}
            paginationModel={paginationModel}
            loading={loading}
            disableColumnMenu={true}
          />
        </>
      ) : (
        <>
          <CustomerProfile setOpenTab={setOpenTab} seletecRow={seletecRow} />
        </>
      )}
    </div>
  );
};

export default Customers;
